import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-commande-edit-return-dialog',
  templateUrl: './commande-edit-return-dialog.component.html',
  styleUrls: ['./commande-edit-return-dialog.component.scss']
})
export class CommandeEditReturnDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CommandeEditReturnDialogComponent>,
    private router: Router
  ) {
  }

  confirm() {
    this.dialogRef.close();
    this.router.navigate(['/escli/linge-hebergement/list'])
  }

  refuse(): void {
    this.dialogRef.close();
  }
}